import React, { Component } from "react";

type Props = {
  url: string,
  width: string,
  height: string,
};

type State = {
  width: string,
  height: string,
  loading: boolean,
};

class ProjectImage extends Component {
  props: Props;
  state: State = {
    width: this.props.width,
    height: this.props.height,
    loading: true,
  };

  componentDidMount() {
    if (this.props.url) {
      const img = new Image();
      img.onload = (event) =>
        this.setState(this.calculateImageSizes(event.target));
      img.src = this.props.url;
    }
  }

  // Formula to make all images have the same aspect ratio
  // Projects page picture size is 180x120
  // Aspect ratio is 3:2
  // if w/h (original aspect ratio) > 1.5
  //   set height to 120 and calculate width
  // else set width to 180 and adapt height
  calculateImageSizes = (target) => {
    if (target.width / target.height < this.props.width / this.props.height)
      return {
        width: this.props.width,
        height: (this.props.width / target.width) * target.height,
        loading: false,
      };
    return {
      height: this.props.height,
      width: (this.props.height / target.height) * target.width,
      loading: false,
    };
  };

  render() {
    return (
      <div
        className="picture"
        style={{ width: this.props.width, height: this.props.height }}
      >
        {this.props.url && !this.state.loading ? (
          <img
            src={this.props.url}
            width={this.state.width}
            height={this.state.height}
            style={{ width: this.state.width, height: this.state.height }}
          />
        ) : (
          <div className="blank">&nbsp;</div>
        )}
      </div>
    );
  }
}

export default ProjectImage;



// WEBPACK FOOTER //
// ./src/views/user/components/project-image/ProjectImage.js